import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { BooleanInput, FormWithRedirect, ReferenceInput, SelectInput, TextInput, Toolbar } from "react-admin";
import { CustomDatetime } from "../../../../Components/CustomDatetime";
import CreatedByInput from "../../../../Components/ReferenceFields/CreatedBy/CreatedByInput";
import { SourceCustomer } from "../../Customer";

const RemoveReasonEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                    <BooleanInput label="Active/Passive" source="isActive" />
                    <BooleanInput label="IsRequired" source="isRequired" />
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                        <ReferenceInput
                          label="CUSTOMER"
                          source="customerId"
                          perPage={99999}
                          required
                          reference={SourceCustomer}
                          filters={{ isActive__eq: true }}
                          fullWidth
                        >
                          <SelectInput optionText="customerId" optionValue="customerName" />
                        </ReferenceInput>
                      </Box>
                    </Box>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput disabled fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>

                  <Box mt="1em">
                    <Typography variant="h6" gutterBottom color="primary">
                      Updatable Field
                    </Typography>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="removeReasonTypeCode" label="REMOVE REASON CODE" required fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="removeReasonTypeName" label="REMOVE REASON NAME" required fullWidth />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={true}
              invalid={formProps.invalid}
              handleSubmit={formProps.handleSubmit}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default RemoveReasonEditForm;
